import { Component, OnInit, ViewChild, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ISubscription } from 'rxjs/Subscription';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { OwlCarousel } from 'ngx-owl-carousel';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { ManuscriptList } from '../../../models/manuscript';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrls: ['./home-carousel.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeCarouselComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    @ViewChild('homeCarousel') homeCarousel: OwlCarousel;
    mssList: ManuscriptList;
    thumbs$: Array<Observable<SafeUrl>> = [];
    loading: Array<boolean> = [];
    carouselOptions = {
        autoplay: false,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        loop: true,
        margin: 10,
        dots: true,
        nav: false,
        onChanged : this.carouselEvent.bind(this),
        onDragged : this.carouselEvent.bind(this),
        // navElement: 'div',
        navText: [
            '<i class="fa fa-arrow-left"></i>',
            '<i class="fa fa-arrow-right"></i>'
        ],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    };

    constructor(
        private http: HttpClient,
        private domSanitizer: DomSanitizer,
        private manuscriptsService: ManuscriptsService) {
    }

    ngOnInit(): void {
        const carouselMss = [25, 12, 154, 55, 28, 172, 137, 20, 46, 1, 2, 7, 60, 21, 13, 16];
        this.subscriptions.push(
            this.manuscriptsService.getManuscripts(false).subscribe(
                response => {
                    this.mssList = response.filter(ms => carouselMss.includes(ms.pkid));
                    this.loadThumbs();
                },
                err => console.error(err)
            )
        );
    }

    loadThumbs() {
        for (let i = 0; i < this.mssList.length; i++) {
            this.loading[i] = true;
            const msRow = this.mssList[i];
            const thumbUrl = environment.endpoints.images.thumbs + '/n/'
                + (msRow.images_linked > 0 ? msRow.__imagesFolder :
                    (msRow.fkidms_types === 2 /* attested */ ? 'book' : 'hourglass')
                )
                + '.tif&CVT=jpeg';

            /* Load thumb images of the current page */
            this.thumbs$[i] = this.http.get(
                thumbUrl,
                {
                    headers: new HttpHeaders({
                        'Authorization': environment.apiKey,
                        'X-PhiBor-App': environment.phiborApp
                    }),
                    responseType: 'blob'
                }
            )
                .map(blob => {
                    this.loading[i] = false;
                    return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
                });
        }
    }

    carouselEvent(event: any): void {
        // carousel event handler
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/home-carousel/home-carousel.component.ts